import { Component, Input } from '@angular/core'

@Component({
  selector: 'hs-app-container',
  templateUrl: './app-container.component.html',
  styleUrls: ['./app-container.component.scss'],
})
export class AppContainerComponent {
  @Input() appIconUrl = ''
  @Input() appTitle = ''
  @Input() env = ''
  @Input() region = ''
  @Input() errorLogSize = 0
}
